import { connect } from "react-redux";
import Login from "../../screens/Authentication/login";
import { toggleLoading, openSnackbar, setProfile } from "../../actions/GeneralAction/general";

const mapStateToProps = (state) => {
  return {
    loading: state.general.loading,
    showSnackbar: state.general.showSnackbar,
    snackbarMessage: state.general.snackbarMessage,
    profile: state.general.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLoading: () => {
      dispatch(toggleLoading());
    },
    openSnackbar: (message, snackbarPosition) => {
      dispatch(openSnackbar(message, snackbarPosition));
    },
    setProfile: (data) => {
      dispatch(setProfile(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
